module.exports = function(media) {
	'use strict';
	media.directive('uploadApprovalRestrictionsModal',uploadApprovalRestrictionsModal);
	uploadApprovalRestrictionsModal.$inject=['jQuery','$http','API_URL','authtokenService','getDataService','$rootScope','activeClass','refreshtokenService','config','$timeout','NgTableParams','serverError','postDataService','alertService','offlineError'];
	function uploadApprovalRestrictionsModal(jQuery,$http,API_URL,authtokenService,getDataService,$rootScope,activeClass,refreshtokenService,config,$timeout,NgTableParams,serverError,postDataService,alertService,offlineError) {
		return {
			restrict: 'E',
			scope: {
		      currentPostObj:"="
		    },
		 	template: require('./partial/uploadApprovalRestrictions.html'),
		    link: function (scope, element, attrs) {
				scope.idsForApproval = [];
				for (var i = 0;i<scope.currentPostObj.checkedPostsEdit.length;i++) {
					scope.idsForApproval.push(scope.currentPostObj.checkedPostsEdit[i]._id);
		      
				}
			}	
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/mediaModule/library/js/directive/uploadApprovalRestrictionsDirective.js
// module id = 518
// module chunks = 0